// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html{margin: 0; padding: 0; font-family: 'Helvetica', 'Arial', sans-serif; font-size: 18px; height: 100%; background: linear-gradient(180deg, #2d5021 0%, #71a441 100%);}
input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {-webkit-appearance: none; margin: 0;}
input[type=number] {-moz-appearance:textfield;}

#wrapper{display: none; position:fixed; left: 50%; top: 50%;}
#wrapper_inner{text-align: center; position: relative; transform: translate(-50%, -50%); background: white; color: black; border-radius: 10px; padding: 20px; min-width: 320px; filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.419));}
#wrapper_inner button{background: #2d5021; border: none; color: whitesmoke; padding: 5px; border-radius: 5px;}

#from_ammount{font-size: 22px; border: none; border-bottom: 1px solid black; background: white; width: 80px;}
#balances{margin: 0 auto 10px auto; display: inline-block; text-align: left; line-height: 30px;}

#header_img{width: 150px; vertical-align: bottom; margin-bottom: 3px;}
#header{font-size: 28px; margin-bottom: 20px; text-align: center;}
#bridge_header{display: inline-block; color: #2e5222; font-weight: 400;}

#bridge{text-align: center; line-height: 30px;}
#reverse{width: 20px; margin: 10px auto; border: 1px solid #2d5021; border-radius: 5px; display: inline-block; padding: 8px; margin: 8px; cursor: pointer;}
#do_swap{font-size: 25px; padding: 8px; width: 80%; margin-top: 10px; display: inline-block;}

#chain_select{padding: 5px; background-color: #fff; border: 1px solid #2d5021; border-radius: 4px; color: #000; cursor: pointer; font-size: 18px;}
#address{position: absolute; bottom: 4px; left: 4px; font-size: 0.7em; color: whitesmoke;}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
